module.exports = __webpack_public_path__ + "img/center front length from empire seam to hem.3c69f3bb.png";